export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.colors.primary.white,
    },
    copilotIcon: {
        display: 'flex',
        alignItems: 'center',
        width: 60,
        padding: '16px 0 4px 0',
        justifyContent: 'center',
    },
    closeIcon: {
        position: 'absolute',
        right: 20,
        top: 20,
    },
    mainContent: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        height: '100%',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.32)',
        borderRadius: '0px 0px 16px 16px',
    },
    verticalTabs: {
        width: 90,
        background: theme.colors.background.utility025,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
    },
    tabButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        color: '#fff',
        border: 'none',
        padding: '8px 0',
        width: '75px',
        cursor: 'pointer',
        outline: 'none',
        fontWeight: 'normal',
        transition: 'background 0.2s, font-weight 0.2s',
        marginTop: 12,
        '&:hover': {
            background: theme.colors.actionMinor[25],
            borderRadius: 12,
            '& svg path': {
                fill: theme.colors.actionMinor[550],
            },
        },
    },
    tabButtonActive: {
        background: theme.colors.primary.white,
        borderRadius: 12,
        fontWeight: 'bold',
    },
    tabContent: {
        flex: 1,
        overflow: 'hidden',
        backgroundColor: theme.colors.primary.white,
    },
    tabContentContainer: {
        height: 'calc(100% - 64px)',
        overflow: 'auto',
        marginTop: 64,
    },
    tabIcon: {
        width: 24,
        height: 24,
        '& svg': { width: '24px !important', height: '24px !important' },
    },
});
